import { useAppRouter as d } from "../../components/providers/AppRouterProvider/AppRouterProvider.js";
import { failActiveJourney as g, handleRouteChange as n, registerJourneys as u, unregisterJourneys as p } from "../../helpers/operations/journeyTracker.js";
import { useEffect as w } from "react";
var v = (r) => {
  const { getCurrent: e, onRouteChange: o } = d();
  w(() => {
    u(r), n(e());
    const s = o(n), t = () => g("abandoned", { trigger: "pagehide" }), i = (a) => {
      a.persisted && n(e());
    };
    return window.addEventListener("pagehide", t), window.addEventListener("pageshow", i), () => {
      s(), window.removeEventListener("pagehide", t), window.removeEventListener("pageshow", i), p();
    };
  }, [
    e,
    o,
    r
  ]);
};
export {
  v as useJourneyTracking
};

//# sourceMappingURL=useJourneyTracking.js.map